var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('svg',{attrs:{"width":"20","height":"20"}},[_c('use',{attrs:{"xlink:href":"#loader"}})]),_c('span',[_vm._v(_vm._s(_vm.$t('forms.loader.loading')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }